import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDemoAuth } from '../../context/DemoAuthContext';
import './UserDemoPage.css';

const UserDemoPage = () => {
  const navigate = useNavigate();
  const { user, logout } = useDemoAuth();

  const handleLogout = () => {
    logout();
    navigate('/demo-login');
  };

  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <div className="user-demo-container">
      <nav className="user-demo-nav">
        <div className="nav-brand">
          <h2>Oakland AI - User Dashboard</h2>
        </div>
        <div className="nav-user">
          <span>Welcome, {user.name}!</span>
          <button onClick={handleLogout} className="logout-btn">
            Logout
          </button>
        </div>
      </nav>

      <main className="user-demo-main">
        <div className="welcome-section">
          <h1>Welcome to Your Dashboard</h1>
          <p>This is the regular user demo page. You can access basic features here.</p>
        </div>

        <div className="user-info-card">
          <h3>Your Profile</h3>
          <div className="profile-grid">
            <div className="profile-item">
              <label>Name:</label>
              <span>{user.firstName} {user.lastName}</span>
            </div>
            <div className="profile-item">
              <label>Email:</label>
              <span>{user.email}</span>
            </div>
            <div className="profile-item">
              <label>Business Type:</label>
              <span>{user.businessType}</span>
            </div>
            <div className="profile-item">
              <label>Language:</label>
              <span>{user.language}</span>
            </div>
            <div className="profile-item">
              <label>User ID:</label>
              <span>{user.id}</span>
            </div>
            <div className="profile-item">
              <label>Role:</label>
              <span className="role-badge user">Regular User</span>
            </div>
          </div>
        </div>

        <div className="features-grid">
          <div className="feature-card">
            <h4>Chat with AI</h4>
            <p>Access the main chat functionality</p>
            <button 
              onClick={() => navigate('/fullchat')}
              className="feature-btn"
            >
              Go to Chat
            </button>
          </div>

          <div className="feature-card">
            <h4>View Analytics</h4>
            <p>Check your business analytics</p>
            <button 
              onClick={() => navigate('/analytics')}
              className="feature-btn"
            >
              View Analytics
            </button>
          </div>

          <div className="feature-card">
            <h4>Profile Settings</h4>
            <p>Update your profile information</p>
            <button className="feature-btn disabled">
              Coming Soon
            </button>
          </div>

          <div className="feature-card">
            <h4>Support</h4>
            <p>Get help and support</p>
            <button className="feature-btn disabled">
              Coming Soon
            </button>
          </div>
        </div>

        <div className="demo-note">
          <h4>Demo Information</h4>
          <p>This is a simplified demo version. In a real application, you would have access to:</p>
          <ul>
            <li>Full chat history</li>
            <li>Detailed analytics</li>
            <li>Profile management</li>
            <li>Business insights</li>
            <li>Customer support</li>
          </ul>
        </div>
      </main>
    </div>
  );
};

export default UserDemoPage;
